import { useState } from 'react';

const ImageWithFallback = ({ src, alt, className }: { src: string; alt: string; className: string }) => {
  const [isError, setIsError] = useState(false);

  if (isError) return null; // Do not render the img if an error occurs

  return <img alt={alt} className={className} src={src} onError={() => setIsError(true)} />;
};

export default ImageWithFallback;
